<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <!-- Page Info -->
    <div class="flex-header">
        <student-header *ngIf="student360"
            [pageTitle]="'Announcements'"
            [showYearSelector]="false"></student-header>
        <page-header *ngIf="!student360"
            [pageTitle]="'Announcements'"></page-header>
    </div>

    <!-- Body -->
    <div class="flex-content" style="height: 100%;">

        <!-- Date Input -->
        <div class="dateInput" aria-live="assertive" aria-relevant="additions">
            <tyl-datepicker [value]="inputDate"
                (valueChange)="inputDate = $event; getAnnouncements();"
                label="Announcements For"
                id="txtDateEntry"
                [isRequired]="true"
                [hideRequiredMarker]="true"
                [allowEnter]="true"
                style="width: 185px"></tyl-datepicker>
        </div>

        <!--Announcement Listings-->
        <div role="main" aria-live="polite" [attr.aria-busy]="isBusy">

            <!-- Announcement Sections -->
            <ng-container *ngFor="let tableDatum of tableData; let i = index">
                <ng-container *ngIf="showTableFlags[i]">

                    <!-- School Announcements -->
                    <ng-container *ngIf="i == 1">

                        <!-- Announcement section header -->
                        <div role="heading"
                            class="sectionHeader">
                            <span translate>School Announcements</span>
                        </div>

                        <!-- Section for each school -->
                        <ng-container *ngFor="let school of schoolNames">

                            <!-- School Header -->
                            <div style="display: flex; align-content: stretch; margin-top: 15px;">
                                <button *ngIf="!student360"
                                    (click)="schoolExpanded[school] = !schoolExpanded[school]"
                                    style="padding-right: 8px; padding-bottom: 4px; background: none; border: none;"
                                    [ngClass]="{
                                        'detail-row-expanded-icon': schoolExpanded[school],
                                        'detail-row-collapsed-icon': !schoolExpanded[school]
                                    }">
                                </button>
                                <span role="heading"
                                    class="schoolHeader"
                                    [ngStyle]="{'padding-left': student360 ? '120px' : 'initial'}">
                                    <span translate>{{school}}</span>
                                </span>
                            </div>

                            <!-- School Announcement Table -->
                            <announcement-table *ngIf="student360 || schoolExpanded[school]"
                                [tableData]="tableDatum | announcementFilter: school"
                                [classAnnouncements]="i == 2"></announcement-table>
                        </ng-container>
                    </ng-container>

                    <!-- Other Announcements -->
                    <ng-container *ngIf="i != 1">

                        <!-- Announcement section header -->
                        <h1 role="heading" class="sectionHeader" translate>{{sectionNames[i]}}</h1>

                        <!-- Announcement Table -->
                        <announcement-table [tableData]="tableDatum"
                            [classAnnouncements]="i == 2"></announcement-table>
                    </ng-container>
                </ng-container>
            </ng-container>

            <!-- Message for no announcements -->
            <div *ngIf="noAnnouncements" translate>
                No announcements for selected date
            </div>
        </div>
    </div>
</tyl-kendo-pdf-export>
<!-- Footer -->
<div class="flex-footer">
    <expand-collapse-buttons [expandEmitter]="toggleAllRows"></expand-collapse-buttons>
    <div class="footerRight">
        <tyl-button *ngIf="districtMessages.length > 0" image="announcement icon.png" label="District Message" (clickEvent)="showDistrictMessages()"></tyl-button>
    </div>
</div>
